import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { postCarePlan } from '../../../../apis/carePlan';
import {
  getPatientById,
  postPatient,
  putPatient,
} from '../../../../apis/patient';
import { getQuestionnaires } from '../../../../apis/questionnaire';
import { PatientFormCardComponent } from '../../../../components/Cards';
import { PatientFormValues } from '../../../../components/Forms/Patient';
import { CarePlanContext } from '../../../../contexts/carePlan';
import { useOrganization } from '../../../../contexts/organization';
import { createEolCarePlan } from '../../../../modules/unsw-care-plan';
import { createPatient } from '../../../../modules/unsw-fhir/Patient';
import { AdministrativeGender } from '../../../../modules/unsw-fhir/Primitives';
import { getPatientFomValues } from '../../../../selectors/patient';

const PatientForm = ({
  onComplete,
  patientId,
}: {
  onComplete?: (patientId: string) => void;
  patientId?: string;
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [patient, setPatient] = useState<PatientFormValues | undefined>(
    undefined,
  );
  useEffect(() => {
    const tsk = async () => {
      try {
        setLoading(true);
        if (!patientId) {
          setPatient(undefined);
          return;
        }
        const patient = await getPatientById(patientId);
        if (!patient) {
          setPatient(undefined);
          return;
        }
        const patientFormValues = getPatientFomValues(patient);
        setPatient(patientFormValues);
      } finally {
        setLoading(false);
      }
    };
    if (patientId) {
      tsk();
    }
  }, [patientId]);
  const { organization } = useOrganization();
  return (
    <CarePlanContext.Consumer>
      {({ carePlan, setCarePlan }) => (
        <PatientFormCardComponent
          initialValues={patient}
          loading={loading}
          onSubmit={async values => {
            if (
              !values.firstName ||
              !values.lastName ||
              !values.gender ||
              !values.dateOfBirth ||
              !values.mrn
            )
              return 'Missing Fields';
            const patientOj = createPatient(
              values.firstName,
              values.lastName,
              moment(values.dateOfBirth).format('YYYY-MM-DD'),
              values.gender.value as AdministrativeGender,
              values.mrn,
              patientId,
              organization && organization.id,
            );
            const patient = patientId
              ? await putPatient(patientId, patientOj)
              : await postPatient(patientOj);
            if (!carePlan) {
              const questionnaires = await getQuestionnaires(true);
              const carePlan = createEolCarePlan({
                patient: { resourceType: 'Patient', id: patient!.id! },
                organization: organization!,
                questionnaires,
              });

              await setCarePlan(carePlan);
              await postCarePlan(carePlan);
            }
            if (onComplete && patient && patient.id) {
              onComplete(patient.id);
            }
          }}
        />
      )}
    </CarePlanContext.Consumer>
  );
};
export default PatientForm;
